import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  approveSubStepStage,
  getWorkflowCase,
  listWorkflowCases,
} from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * サブステップ承認ステージを承認する mutation hook。
 * onSuccess で detail + list query を invalidate する。
 */
export function useApproveSubStepStage(
  caseId: string,
): InvalidatingMutationResultFor<typeof approveSubStepStage> {
  return useInvalidatingMutation(approveSubStepStage, [
    createConnectQueryKey({
      schema: getWorkflowCase,
      cardinality: 'finite',
      input: { id: caseId },
    }),
    createConnectQueryKey({ schema: listWorkflowCases, cardinality: 'finite' }),
  ])
}
